<template>
  <div class="digitRoll-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1">
        <div class="data-source-type" v-if="!noCacheComponentLayout && (isBigScreen && !layoutOptions.noCacheComponent) || (!isBigScreen && !showColsFieldMapping)">
          <cx-slider :value.sync="noCacheComponent" :options="dataOptions" :height="32" />
        </div>
        <div v-show="noCacheComponent && !noCacheComponentLayout" class="mt16">
          <!-- <div class="dataSource-item mt12" @click="goToChooseData">
            <span>进入数据管理后台 </span>
          </div> -->
          <data-center-choose
            :checkStatus="checkStatus"
            :myId="ids"
            :options="options"
            class="mt12"
            @onDataCenterChange="onDataCenterChange"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="showColsFieldMapping && layoutOptions.noCacheComponent"
        @mousedown.native="collapseMouseDown($event, '2')"
        title="数据绑定"
        name="2"
      >
        <div class="content">
          <colsFieldMappingSetting :ids="ids" :options="options"></colsFieldMappingSetting>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '3')" title="数据内容" name="3" v-if="!noCacheComponentLayout">
        <div class="content">
          <div class="content-item verticallyCenter">
            <single-input
              style="width: 100%"
              :value.sync="content"
              :noInputSuffixs="true"
            />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '4')" title="预警设置" name="4">
        <div class="content">
          <div class="content-item mb16">
            <el-checkbox v-model="onWarning">开启预警</el-checkbox>
            <div class="mt16" v-if="onWarning">
              <div v-for="(item, index) in dynamicData" :key="index" class="content-item mb16 specialRows_content">
                <div class="delete-btn" @click="deleteDynamicDataHandle(index)">
                  <span class="icon-portal-delete1"></span>
                </div>
                <div class="data-item mb12">
                  <div class="font14 mb8">当文本内容</div>
                  <el-select style="width: 183px; height: 32px" v-model="item.condition" @change="getDynamicDataConditionHandle(index, $event)">
                    <el-option v-for="(item1, index1) in conditionList" :key="index1" :label="item1" :value="item1">
                      {{ item1 }}
                    </el-option>
                  </el-select>
                </div>
                <!-- 多值判断 -->
                <div v-if="item.condition === '介于'" class="data-item mb8">
                  <single-input
                      @change="getDynamicDataConditionRange1Handle(index, $event, 0)"
                      style="width: 64px; height: 32px"
                      :value.sync="item.conditionRange[0]"
                      :noInputSuffixs="true"
                  />
                  <span> < 值 <= </span>
                  <single-input
                      @change="getDynamicDataConditionRange1Handle(index, $event, 1)"
                      style="width: 64px; height: 32px"
                      :value.sync="item.conditionRange[1]"
                      :noInputSuffixs="true"
                  />
                </div>
                <!-- 单值判断 -->
                <div v-if="item.condition !== '介于'" class="data-item mb8">
                  <el-input
                      v-model="item.parameter"
                      @change="getDynamicDataParameterHandle(index, $event)"
                      placeholder="请输入"
                  ></el-input>
                </div>
                <!-- 主题样式为“纯色”和“边框”时 -->
                <div v-if="bgColorType === '纯色' || bgColorType === '边框'">
                  <div class="fs14 mb8">主题颜色</div>
                  <div class="color-picker-container custom-text-bg" style="width: 100%">
                    <el-color-picker class="" v-model="item.resultBgColor" color-format="rgb" :show-alpha="true"></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ item.resultBgColor }}</span>
                  </div>
                </div>
                <!-- 主题样式为“渐变”时 -->
                <div v-if="bgColorType === '渐变'">
                  <div class="mb8">
                    <span class="mr16 fs14">开始颜色</span>
                    <div class="color-picker-container custom-text-bg custom-text-bg-jb">
                      <el-color-picker
                          class=""
                          v-model="item.resultBgStartColor"
                          color-format="rgb"
                          :show-alpha="true"
                      ></el-color-picker>
                      <span class="floatLeft color-text mr8">{{ item.resultBgStartColor }}</span>
                    </div>
                  </div>
                  <div>
                    <span class="mr16 fs14">结束颜色</span>
                    <div class="color-picker-container custom-text-bg custom-text-bg-jb">
                      <el-color-picker
                          class=""
                          v-model="item.resultBgEndColor"
                          color-format="rgb"
                          :show-alpha="true"
                      ></el-color-picker>
                      <span class="floatLeft color-text mr8">{{ item.resultBgEndColor }}</span>
                    </div>
                  </div>
                  <div class="slider-input-container mt8 paddingl0">
                    <span class="mr16 fs14">渐变角度</span>
                    <el-slider
                        :show-tooltip="false"
                        class="mr16"
                        style="width:60px; height: 4px"
                        v-model="item.resultBgColorlinearGradientAngle"
                        :max="360"
                        :min="0"
                    ></el-slider>
                    <single-input
                        style="width: 60px; height: 28px"
                        :value.sync="item.resultBgColorlinearGradientAngle"
                        :max="360"
                        inputSuffixs="度"
                    />
                  </div>
                </div>
                <!-- 主题样式为“图片”时 -->
                <div v-if="bgColorType === '图片'">
                  <p class="mb8">主题图片</p>
                  <img-upload-simple class="mb12" :imgSrc.sync="item.resultBgImage" />
                </div>
                <div>
                  <div class="fs14 mb8">文本颜色</div>
                  <div class="color-picker-container custom-text-bg" style="width: 100%">
                    <el-color-picker class="" v-model="item.resultFontColor" color-format="rgb" :show-alpha="true"></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ item.resultFontColor }}</span>
                  </div>
                </div>
                <div v-if="showIcon">
                  <div class="fs14 mt12 mb8">图标样式</div>
                  <div class="content-item mt12">
                    <img-icon-upload
                        class="mb16"
                        :imgSrc.sync="item.resultIconSrc"
                        :iconType.sync="item.resultIconType"
                        :iconColor.sync="item.resultIconColor"
                        :resInfo.sync="item.resultResInfo"
                    />
                  </div>
                  <div class="verticallyCenter mb16" v-if="item.resultIconType === 'icon'">
                    <span class="mr16 fs14">颜色</span>
                    <cx-color-picker class="flex1" :isThemeColor.sync="item.resultIconColorIsThemeColor" :colorArr.sync="item.resultIconColor">
                    </cx-color-picker>
                  </div>
                </div>

              </div>
              <div class="addConditionBtn mt12" @click="addDynamicDataHandle">
                <span class="icon-portal-plus mr2"></span>
                <span class="">添加条件</span>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item v-show="noCacheComponent && !noCacheComponentLayout" @mousedown.native="collapseMouseDown($event, '5')" title="更多" name="5">
        <div>
          <div class="mb16 dataType-item">
            <cx-check-box class="mr8" @change="val => (getDataCount = !val)" :value="getDataCount === false"
              >获取数据内容</cx-check-box
            >
            <cx-check-box @change="val => (getDataCount = val)" :value="getDataCount === true"
              >获取数据数量</cx-check-box
            >
          </div>
          <div class="mb16" v-if="request_prefix === 'bigScreen'">
            <cx-check-box :value.sync="emptyDataShowLocal">
              <span>空数据时显示以下内容</span>
              <el-tooltip
                popper-class="width200"
                effect="dark"
                content="勾选后，空数据时组件显示以下内容；不勾选时，空数据时组件为NAN"
                placement="top"
                :open-delay="1000"
              >
                <span class="tips-btn icon-portal-info2"></span>
              </el-tooltip>
            </cx-check-box>
            <el-input
              v-if="emptyDataShowLocal"
              class="mt8"
              v-model="emptyContent"
              placeholder="请输入"
              type="text"
            ></el-input>
          </div>
          <auto-update-timer :isLocal="!(noCacheComponent && !noCacheComponentLayout)"/>
          <!-- <div class="getDataBtn mb16" @click="getBaseModuleDataLoop">查看数据响应结果</div> -->
          <cx-check-box  v-if="request_prefix==='bigScreen'"  :value.sync="usePageQuery">开启跨页面传参</cx-check-box>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import colsFieldMappingSetting from "publicSetting/colsFieldMappingSetting.vue"
import { isExist } from "utils"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
export default {
  name: "digitRoll-options-data",
  components: { autoUpdateTimer, colsFieldMappingSetting, dataCenterChoose },
  props: {
    options: { type: Object }
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1", "2"],
      collapseActiveNames: [],
      fetchEnd: false,
      conditionList: ["等于", "不等于", "大于", "小于", "大于等于", "小于等于", "介于"],
      dataOptions: [{ value: false, title: "本地数据" }, { value: true, title: "数据中心" }]
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    content: {
      get() {
        let result = this.options.content
        if(this.options.decimal){
          if(typeof result !== "string"){
            result = result + ""
          }
          result = result.split(".")[0]
        }
        if(this.options.showThousandSeparator){
          if(typeof result !== "string"){
            result = result + ""
          }
          let arr1 = result.split(",")
          let num1 = ''
          for (let i = 0; i < arr1.length; i++) {
            num1 = num1 + arr1[i]
          }
          result = num1
        }
        return result
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "content", false)
      }
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl !== "" ? this.options.restDataUrl : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    getDataCount: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "getDataCount", "getDataCount", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "getDataCount", false)
      }
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null)
      }
    },
    emptyDataShowLocal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "emptyDataShowLocal", "emptyDataShowLocal", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyDataShowLocal", false, null)
      }
    },
    emptyContent: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "emptyContent", "emptyContent", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyContent", false, null)
      }
    },
    onWarning: {
      get() {
        return this.options.onWarning || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "onWarning", false, null)
      }
    },
    bgColorType: {
      get() {
        return this.options.bgColorType
      }
    },
    dynamicData: {
      get() {
        if (this.onWarning) {
          // 序列表格才有数据组
          return this.options.dynamicData || []
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dynamicData", false, null)
      }
    },
    showIcon: {
      get() {
        return this.options.showIcon || false
      }
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    showColsFieldMapping() {
      return this.ids?.uid || isExist(this.ids?.elementInSwiperId)
    },
    noCacheComponentLayout() {
      // 在四边栏中 不控制
      if (!this.showColsFieldMapping) return false
      // 在中间内容区
      let rectAttr = this.layoutOptions
      let filedMapping = this.options && this.options.filedMapping && this.options.filedMapping.flag
      if (rectAttr && rectAttr.innerElement !== "emptyLayoutComponent" && rectAttr.innerElement !== "swiperComponent") return false
      else return filedMapping && rectAttr && rectAttr.noCacheComponent
    },
    layoutOptions() {
      let rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids, "rect")?.options
      if (rectAttr && isExist(this.ids.elementInAutoLayoutId) && isExist(this.ids.elementInLayoutId) && rectAttr.innerElement === "cxAutoLayout") {
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], { ...this.ids, elementInLayoutId: undefined })
      }
      if (rectAttr && rectAttr.innerElement !== "emptyLayoutComponent" && rectAttr.innerElement !== "swiperComponent" || !rectAttr.noCacheComponent) return {}
      return rectAttr
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
    }
  },
  mounted() {
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid, homePageId, pageType } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (appId === undefined) appId = rectAttr?.options?.appId
      if (!!!moduleId || !!!appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
          .then(res => {
            this.fetchEnd = false
            if (!!res.appId) {
              window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&init=1`)
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (!!appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}`)
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
        .call(this, datas => {
          /*大屏外接数据空数据展示位NAN*/
          if (this.request_prefix == "bigScreen" && datas.length === 0) {
            if (this.emptyDataShowLocal) {
              this.content = this.emptyContent
            } else {
              this.content = "NAN"
            }
          }
          this.content = datas[0][Object.keys(datas[0])[0]].value
          if(this.request_prefix === "bigScreen" && !this.content && this.content !== 0){
            if (this.emptyDataShowLocal) {
              this.content = this.emptyContent
            } else {
              this.content = "NAN"
            }
          }
        })
        .then(restDataUrl => {
          this.restDataUrl = restDataUrl
        })
    },
    // 删除数据条件 点击事件
    deleteDynamicDataHandle(index) {
      let dynamicData = JSON.parse(JSON.stringify(this.options.dynamicData))
      dynamicData.splice(index, 1)
      this.$changeOptionsEV(dynamicData, "dynamicData", false)
    },
    // 数据改变条件
    getDynamicDataConditionHandle(index, $event) {
      this.$changeOptionsEV($event, "dynamicData." + index + ".condition", false)
    },
    // 数据改变条件范围1
    getDynamicDataConditionRange1Handle(index, $event, index1) {
      let conditionRange = this.options.dynamicData[index].conditionRange
      conditionRange[index1] = $event
      this.$changeOptionsEV(conditionRange, "dynamicData." + index + ".conditionRange", false)
    },
    // 数据改变参数值
    getDynamicDataParameterHandle(index, $event) {
      this.$changeOptionsEV($event, "dynamicData." + index + ".parameter", false)
    },
    // 添加数据条件 点击事件
    addDynamicDataHandle() {
      let addDynamicData = {
        condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
        conditionRange: [],
        parameter: "", // 参数值
        resultBgColor: this.options.bgColor,
        resultFontColor: this.options.fontColor,
        resultIconSrc: "",
        resultIconType: "",
        resultIconColor: "",
        resultResInfo: {},
        resultIconColorIsThemeColor: false,
        resultBgStartColor: "",
        resultBgEndColor: "",
        resultBgColorlinearGradientAngle: "",
        resultBgImage: "",
      }
      let dynamicData = []
      if(this.options.dynamicData !== undefined){
        dynamicData = JSON.parse(JSON.stringify(this.options.dynamicData))
      }
      dynamicData.push(addDynamicData)
      this.$changeOptionsEV(dynamicData, "dynamicData", false)
    },
    onDataCenterChange() {
      this.getBaseModuleDataLoop()
    },
    updateToolbarData() {
      this.getBaseModuleDataLoop()
    }
  }
}
</script>

<style lang="scss" scoped>
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.dataType-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: var(--fourthTextColor);
}
.specialRows_content {
  border: 1px solid #313336;
  border-radius: 4px;
  padding: 12px;
  position: relative;
}
.specialRows_content .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  background: var(--sliderBackGround);
  border-radius: 0 4px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.specialRows_content .delete-btn .icon-portal-delete1 {
  top: 5px;
  left: 5px;
  position: absolute;
}
.specialRows_content .delete-btn .icon-portal-delete1:before {
  color: var(--toolbarTipText);
}
.specialRows_content .color-picker-container.custom-container-bg {
  width: calc(100% - 80px);
  display: inline-block;
  vertical-align: middle;
}
.addConditionBtn {
  border: 1px solid var(--themeColor);
  box-sizing: border-box;
  border-radius: 4px;
  width: 102px;
  height: 32px;
  font-size: 14px;
  line-height: 20px;
  color: var(--themeColor);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
<style>
.width200 {
  width: 200px;
}
</style>
